<template>
  <div>
    <a-card title="工具配置">
      <a href="#" slot="extra">
        <a-button type="primary" @click="showModal({}, 1)">新增工具</a-button>
      </a>
      <a-table :columns="columns" :dataSource="data" rowKey="id" :loading="loading">
        <div slot="sort" slot-scope="text, record, index">
          <a-input v-model="text" @change="handleSortChange(record, $event, index)" ref="input" @blur="sortHandle(record, $event, index)" maxLength="25"/>
        </div>
        <span slot="action" slot-scope="text, record">
          <a-button type="primary" @click="showModal(record, 2)" :ghost="true">添加子分类</a-button> &nbsp;&nbsp;
          <a-button type="primary" :ghost="true" @click="showModal(record, 3)">编辑</a-button> &nbsp;&nbsp;
          <a-button type="danger" @click="showDeleteConfirm(record)">删除</a-button> &nbsp;
        </span>
      </a-table>
    </a-card>
    <!-- 注意：新增工具、添加子分类、编辑为同一个组件 -->
    <setup-operation ref="showOperation" @ok="handleOk"/>
  </div>

</template>

<script>
import SetupOperation from './modules/SetupOperation'
import { getToolList, delTool, sortSetUp } from '@/api/manage'

const columns = [{
  title: '工具',
  dataIndex: 'name',
  key: 'name',
  width: '20%'
}, {
  title: '链接',
  dataIndex: 'link_address',
  key: 'link_address',
  width: '30%'
}, {
  title: '排序',
  dataIndex: 'order_num',
  key: 'order_num',
  width: '10%',
  scopedSlots: { customRender: 'sort' }
}, {
  title: '操作',
  dataIndex: 'action',
  width: '30%',
  key: 'action',
  scopedSlots: { customRender: 'action' }
}]
const data = []

export default {
  components: {
    SetupOperation
  },
  data () {
    return {
      data,
      columns,
      // 新增面板控制
      visibleSetUp: false,
      loading: false
    }
  },
  mounted () {
    this.handleInitList()
  },
  methods: {
    handleOk () {
      this.handleInitList()
    },
    sortHandle (record, e, index) {
      return sortSetUp({
        id: record.id,
        orderNum: parseInt(record.order_num)
      })
        .then(res => {
          console.log(this.data)
          this.handleInitList()
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSortChange (record, e, index) {
      console.log(e.data)
      console.log(record)
      if (e.data) {
        record.order_num += e.data
      } else {
        record.order_num = ''
      }
    },
    handleInitList () {
      this.loading = true
      return getToolList({})
        .then(res => {
          this.data = res.result
          console.log(this.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showModal (record, type) {
      this.$refs.showOperation.show(this.data, record, type)
    },
    // 删除
    showDeleteConfirm (record) {
      this.$confirm({
        title: '确定删除当前工具配置?',
        content: '',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.loading = true
          return delTool({
            id: record.id
          })
            .then(res => {
              this.$message.success(res.msg)
              this.handleInitList()
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.loading = false
            })
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    requestFailed (err) {
      console.log(err)
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
